// extracted by mini-css-extract-plugin
export var calendarView = "_ie-0";